import { useEffect, useMemo, useState } from 'react'
import { Link } from "react-router-dom"
import { Table, Select, Space, Input, Button, Form, Modal, Row, Col, Radio, Carousel, DatePicker } from 'antd'
import { RadioChangeEvent } from "antd/lib/radio/interface"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { baseAxiosNoInfo, baseAxiosComplete, axiosTable } from '../../tool/axios'
import { SelectStores } from '../../component/common/Selects'
import { CheckImgs } from "../../component/common/Imgs"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import moment from 'moment'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type pagination = {
  current: number,
  pageSize: number,
  total: number,
}

type fetchParams = {
  store_id: string | undefined,
  customer_name: string | undefined,
  customer_phone: string | undefined,
  employee_id_adviser: string | undefined,
  employee_id_recover: string | undefined,
  order_code: string | undefined,
  date: any,
  review_status: string | undefined,
  final_review_status: string | undefined
}

type orderItemRecord = {
  order_source_type_desc: string | undefined,
  chankang_item_type_desc: string | undefined,
  item_name: string | undefined,
  count: undefined,
  total_amount: undefined,
}

export default function CkCollectionList() {

  let otherParamsTml = {
    store_id: undefined,
    customer_name: undefined,
    customer_phone: undefined,
    employee_id_adviser: undefined,
    employee_id_recover: undefined,
    order_code: undefined,
    date: undefined,
    review_status: undefined,
    final_review_status: undefined
  }

  let paginatioTml = {
    current: 1,
    pageSize: 10,
    total: 0
  }

  const [initDate, setInitDate] = useState<boolean>(true)

  const [otherParams, setOtherParams] = useState<fetchParams>(otherParamsTml)
  const [pagination, setPagination] = useState<pagination>(paginatioTml)

  const [tableList, setTableList] = useState<any[]>([])
  // 汇总数据
  const [summaryData, setSummaryData] = useState<any>([])

  const [finalReviewForm] = Form.useForm()
  const [finalReviewVisble, setFinalReviewVisble] = useState<boolean>(false)
  const [finalReviewData, setFinalReviewData] = useState<{
    order_id: string,
    store_name: string,
    customer_name: string,
    customer_phone: string,
    order_date: undefined,
    actually_deal_amount: undefined,
    employee_name_adviser: string,
    employee_name_recover: string
  } | undefined>()
  const [passType, setPassType] = useState<number | undefined>(undefined)

  const [orderItemData, setOrderItemData] = useState<orderItemRecord[]>([])

  const [urls, setUrls] = useState<string[]>([])
  const [swiperVisible, setSiperVisible] = useState<boolean>(false)

  const [adviseEmployeeList, setAdviseEmployeeList] = useState<any[]>([])
  const [recoverEmployeeList, setRecoverEmployeeList] = useState<any[]>([])

  const getAdviseEmployeeList = adviseEmployeeList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id}  >{el.user_name}</Option>))
  const getRecoverEmployeeList = recoverEmployeeList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id}  >{el.user_name}</Option>))

  const permission: string[] = useMemo(() => {
    return getPermission()
  }, [window.location.pathname])

  useEffect(() => {
    if (initDate) {
      var startDate = moment().startOf('month');
      var endDate = moment().endOf('month');
      // 初始化下单日期
      otherParams.date = [startDate, endDate];

      setInitDate(false)
    }

    fetch({ pagination, otherParams })
  }, [pagination.current])

  const getEmployeeList = (type: any, id: any) => {
    // 查询员工列表，包括：产康顾问、产康师
    baseAxiosNoInfo('/global/employee_list_by_position', { params: { position_number: type, department_id: id } }).then((res: any) => {
      if (res) {
        if (type == 4) {
          setAdviseEmployeeList(res)

        } else {
          setRecoverEmployeeList(res)
        }
      }
    })
  }

  const handleInputChange = (value: string, attr: string) => {
    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setOtherParams(params)
  }

  const handleSelectChange = (value: string, attr: string) => {
    if (attr == 'store_id') {
      getEmployeeList(4, value)
      getEmployeeList(5, value)
    }

    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setOtherParams(params)
  }

  const handleDateChange = (value: any, attr: any) => {
    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setOtherParams(params)
  }

  const handleSearch = () => {
    let p: any = { ...pagination }
    p.current = 1
    setPagination(p)

    fetch({ pagination: p, otherParams })
  }

  const handleTableChange = (antPagination: any) => {
    const p = { ...pagination }
    p.current = antPagination.current

    setPagination(p)
  }

  const fetch = ({ pagination, otherParams }: { pagination: Object, otherParams: object }) => {
    // 清空汇总数据
    setSummaryData("")

    const iPagination: any = { ...pagination }
    iPagination.page_num = iPagination.current
    iPagination.page_size = iPagination.pageSize

    delete iPagination.current
    delete iPagination.pageSize
    delete iPagination.total

    let params: any = { ...otherParams }
    if (params.date) {
      params.create_start_date = params.date[0].format('YYYY-MM-DD')
      params.create_end_date = params.date[1].format('YYYY-MM-DD')

      delete params.date
    }

    axiosTable.get('/finance_center/chankang/pay_records/page_list', {
      params: {
        ...iPagination,
        ...params
      }

    }).then((response: any) => {
      if (response) {
        let p: any = { ...pagination }
        p.total = response.total

        setPagination(p)
        setTableList(response.records)

        // 设置汇总列表数据
        const { chankang_pay_summary } = response
        if (chankang_pay_summary && chankang_pay_summary.length) {
          setSummaryData(chankang_pay_summary)
        }
      }
    })
  }

  const resetForm = () => {
    // 清空初始数据
    setAdviseEmployeeList([]);
    setRecoverEmployeeList([]);

    setInitDate(false)
    setOtherParams(otherParamsTml)

    let p: any = { ...pagination }
    p.current = 1
    setPagination(p)

    fetch({ pagination: p, otherParams: otherParamsTml })
  }

  const exportExcel = () => {
    const iPagination: any = { ...pagination }
    iPagination.page_num = iPagination.current
    iPagination.page_size = iPagination.pageSize

    delete iPagination.current
    delete iPagination.pageSize
    delete iPagination.total

    let params: any = { ...otherParams }
    if (params.date) {
      params.create_start_date = params.date[0].format('YYYY-MM-DD')
      params.create_end_date = params.date[1].format('YYYY-MM-DD')

      delete params.date
    }

    baseAxiosComplete('/finance_center/chankang/pay_records/excel', {
      params: {
        ...iPagination,
        ...params
      }

    }).then(res => {
      if (res.status === 0) {
        window.open(res.data)
      }
    })
  }

  const handlePassChange = (e: RadioChangeEvent) => {
    setPassType(e.target.value)
  }

  // 终审
  const onFinish = (value: any) => {
    baseAxiosComplete.post('/finance_center/chankang/pay_records/final_review', {
      order_id: finalReviewData?.order_id,
      review_status: value.review_status,
      review_refuse_reason: value.review_refuse_reason

    }).then((res: any) => {
      if (res.status === 0) {
        fetch({ pagination, otherParams })
        setFinalReviewVisble(false)
      }
    })
  }

  return <div className="common-page">
    {/* 财务中心 -> 财务管理 -> 产康收款管理 */}
    <BreadCrumb position={['财务中心', '产康收款管理']} />

    <div className="common-top-form">
      <Space direction="horizontal" wrap>
        <div style={{ marginRight: 8, marginBottom: 12 }}>
          <SelectStores valueProp="id" value={otherParams.store_id} onChange={(value: string) => { handleSelectChange(value, 'store_id') }} />
        </div>

        <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.customer_name} placeholder="客户姓名" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'customer_name') }} />
        <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.customer_phone} placeholder="联系方式" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'customer_phone') }} />

        <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.employee_id_adviser} onChange={(value: string) => { handleSelectChange(value, 'employee_id_adviser') }} placeholder="产康顾问">
          {getAdviseEmployeeList}
        </Select>
        <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.employee_id_recover} onChange={(value: string) => { handleSelectChange(value, 'employee_id_recover') }} placeholder="产康师">
          {getRecoverEmployeeList}
        </Select>

        <RangePicker className="fl" style={{ marginRight: 8, marginBottom: 12, width: 250 }} value={otherParams.date} placeholder={['下单开始日期', '下单结束日期']} onChange={(el: any) => (handleDateChange(el, 'date'))} />
        <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.review_status} onChange={(value: string) => { handleSelectChange(value, 'review_status') }} placeholder="初审状态" allowClear>
          <Option value="0">待审核</Option>
          <Option value="1">审核通过</Option>
          <Option value="2">审核未通过</Option>
        </Select>
        <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.final_review_status} onChange={(value: string) => { handleSelectChange(value, 'final_review_status') }} placeholder="终审状态" allowClear>
          <Option value="0">待审核</Option>
          <Option value="1">审核通过</Option>
          <Option value="2">审核未通过</Option>
        </Select>
      </Space>

      <div style={{ marginTop: 10 }}>
        {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
        <Button style={{ marginRight: 12, marginBottom: 12 }} icon={<RedoOutlined />} onClick={resetForm}>重置</Button>
        {permission.includes('导出') && <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed">导出</Button>}
      </div>
    </div>

    <div className="common-main">
      <Table dataSource={tableList} bordered={true} scroll={{ x: 'max-content' }} rowKey="order_id" pagination={pagination} onChange={handleTableChange}>
        <Column title="门店" dataIndex="store_name" key="store_name" />
        <Column title="客户姓名" dataIndex="customer_name" key="customer_name" />
        <Column title="手机号" dataIndex="customer_phone" key="customer_phone" />
        <Column title="下单时间" dataIndex="create_date" key="create_date" />
        <Column title="订单金额" dataIndex="init_deal_amount" key="init_deal_amount" />
        <Column title="成交金额" dataIndex="actually_deal_amount" key="actually_deal_amount" />
        <Column title="产康顾问" dataIndex="employee_name_adviser" key="employee_name_adviser" />
        <Column title="产康师" dataIndex="employee_name_recover" key="employee_name_recover" />

        <Column
          title="收款凭证"
          dataIndex="pay_pic_list"
          key="pay_pic_list"
          render={(v: any) => {
            return <Button onClick={() => {
              setUrls(v)
              setSiperVisible(true)
            }} size="small" >查看</Button>
          }}
        />

        <Column title="初审状态" dataIndex="review_status_desc" key="review_status_desc" />
        <Column title="初审人" dataIndex="review_user_name" key="review_user_name" />
        <Column title="初审时间" dataIndex="review_time" key="review_time" />
        <Column title="初审不通过原因" dataIndex="review_refuse_reason" key="review_refuse_reason" />

        <Column title="终审状态" dataIndex="final_review_status_desc" key="final_review_status_desc" />
        <Column title="终审人" dataIndex="final_review_user_name" key="final_review_user_name" />
        <Column title="终审时间" dataIndex="final_review_time" key="final_review_time" />
        <Column title="终审不通过原因" dataIndex="final_review_refuse_reason" key="final_review_refuse_reason" />

        <Column
          title="操作"
          key="action"
          fixed='right'
          render={(text, record: any) => (
            <Space size="middle">
              {permission.includes('查看') && <Button size="small" type="primary"><Link to={"/ck_order_detail/" + record.order_id + '/' + 'true'}>查看</Link></Button>}
              {permission.includes('终审') && record.final_review_status === 0 &&
                <Button onClick={() => {
                  baseAxiosNoInfo('/finance_center/chankang/pay_records/order_item_list', {
                    params: {
                      order_id: record.order_id
                    }

                  }).then((res: any) => {
                    res && setOrderItemData(res)
                  })

                  finalReviewForm.setFieldsValue({
                    review_status: undefined,
                    review_refuse_reason: undefined,
                  })

                  setFinalReviewData({
                    order_id: record.order_id,
                    store_name: record.store_name,
                    customer_name: record.customer_name,
                    customer_phone: record.customer_phone,
                    order_date: record.create_date,
                    actually_deal_amount: record.actually_deal_amount,
                    employee_name_adviser: record.employee_name_adviser,
                    employee_name_recover: record.employee_name_recover
                  })
                  setFinalReviewVisble(true)
                }} size="small" >终审</Button>
              }
            </Space>
          )}
        />
      </Table>
    </div>

    {/* 汇总数据 */}
    <div className="common-main">
      <h3>汇总</h3>

      <Table dataSource={summaryData} scroll={{ x: 'max-content' }} bordered={true} pagination={false}>
        <Column title="门店名称" dataIndex="store_name" key="store_name" />
        <Column title="订单数" dataIndex="order_num" key="order_num" />
        <Column title="订单总金额" dataIndex="init_deal_amount" key="init_deal_amount" />
        <Column title="成交总金额" dataIndex="actually_deal_amount" key="actually_deal_amount" />
      </Table>
    </div>

    {/* 图片预览 */}
    <CheckImgs tinyURL={urls} visible={swiperVisible} onCancel={() => { setSiperVisible(false) }} />

    {/* 终审弹窗 */}
    <Modal title="终审信息" visible={finalReviewVisble} footer={false} onCancel={() => { setFinalReviewVisble(false) }} width={800}>
      <Row>
        <Col span={11}>
          <div><Space>订单门店：{finalReviewData?.store_name}</Space></div>
          <div><Space>客户姓名：{finalReviewData?.customer_name}</Space></div>
          <div><Space>产康顾问：{finalReviewData?.employee_name_adviser}</Space></div>
          <div><Space>成交金额：{finalReviewData?.actually_deal_amount}</Space></div>
        </Col>

        <Col span={11}>
          <div><Space>订单日期：{finalReviewData?.order_date}</Space></div>
          <div><Space>联系方式：{finalReviewData?.customer_phone}</Space></div>
          <div><Space>产康师：{finalReviewData?.employee_name_recover}</Space></div>
        </Col>
      </Row>

      {/* 订单项目 */}
      <div style={{ margin: '5px' }}>
        <Table pagination={false} dataSource={orderItemData} scroll={{ x: 'max-content' }} bordered={true} rowKey="id">
          <Column title="订单类型" dataIndex="order_source_type_desc" key="order_source_type_desc" />
          <Column title="项目类型" dataIndex="chankang_item_type_desc" key="chankang_item_type_desc" />
          <Column title="项目名称" dataIndex="item_name" key="item_name" />
          <Column title="项目次数" dataIndex="count" key="count" />
          <Column title="项目金额" dataIndex="total_amount" key="total_amount" />
        </Table>
      </div>

      {/* 订单终审 */}
      <Form form={finalReviewForm} onFinish={onFinish} >
        <Form.Item style={{ marginTop: 8, marginBottom: 8 }} label="是否通过" name="review_status" rules={[{ required: true, message: '必须选择是否通过审核' }]}>
          <Radio.Group onChange={handlePassChange} value={passType}>
            <Radio value={1}>通过</Radio>
            <Radio value={2}>不通过</Radio>
          </Radio.Group>
        </Form.Item>

        {passType === 2 && <Form.Item label="备注" name="review_refuse_reason" rules={[{ required: true, message: '必须填写备注' }]}>
          <Input />
        </Form.Item>}

        <Form.Item wrapperCol={{ span: 12, offset: 0 }}>
          <Button type="primary" htmlType="submit">提交</Button>
        </Form.Item>
      </Form>
    </Modal>
  </div>
}